import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=12ac0c94&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=ts"
export * from "./Privacy.vue?vue&type=script&lang=ts"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=12ac0c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ac0c94",
  null
  
)

export default component.exports